<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11NHXx4/tc-custom/9781524866907.jpg?1737798344757" alt="This image is the cover for the book BB3X, Baby Blues Collection"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">BB3X, Baby Blues Collection
      </h1>
      <p class="bookDescription body article font2">
        <i>BB3X</i> is a special <i>Baby Blues</i> treasury that celebrates three decades of one of the most heartwarming, funny, and true-to-life depictions of raising children ever seen in the funny pages. In addition to a year's worth of <i>Baby Blues</i> comics, this special collection sheds light on the unique collaborative process of Rick Kirkman and Jerry Scott, whose cartooning magic has helped transform some of the most stressful moments in life into some of the most hilarious. The book includes a forward from Rick, a reflection by Jerry, and a special "scrapbook" section of archival photographs, memorabilia, and illustrations from the duo's three decades of <i>Baby Blues </i>collaboration.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rick Kirkman, Jerry Scott
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?11df1ffe